export default __webpack_public_path__ + "static/oracle-d4982da5ad3a977eb86c910e12cd31aa.svg";